(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/pay-numbergames/assets/javascripts/api-calls/fetch-wager.js') >= 0) return;  svs.modules.push('/components/numbergames/pay-numbergames/assets/javascripts/api-calls/fetch-wager.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const productMapping = svs.numbergames.productMapping;
const bagTypes = svs.numbergames.pay_numbergames.data.bagTypes;
const boardNames = {
  KENO: 'kenoBoards',
  LOTTO: 'lottoBoards',
  EUROJACKPOT: 'extNumberBoards',
  VIKINGLOTTO: 'extNumberBoards',
  JOKER: 'jokerBoards'
};
async function fetchWager(_ref) {
  let {
    next,
    wagerId
  } = _ref;
  let apiWagers;
  let product;
  let price;
  let syndicateId;
  if (wagerId) {
    const {
      response: {
        wager: responseWager
      }
    } = await svs.core.jupiter.callAsync({
      method: 'GET',
      path: "/player/1/wagers/".concat(wagerId)
    });
    if (responseWager) {
      const {
        wager,
        productName,
        betAmount,
        properties,
        isSystemWager
      } = responseWager;
      product = productMapping.getProductItsId(productName);
      price = parseInt(betAmount, 10);
      syndicateId = properties.syndicateId;
      apiWagers = [{
        bagType: bagTypes.some(b => b.bagType === wager.bagType) ? wager.bagType : 0,
        bets: wager.bets.map(bet => {
          const boardName = boardNames[productMapping.getProductId(bet.productId)];
          const boards = bet[boardName];
          return {
            productId: productMapping.getProductItsId(bet.productId),
            numDraws: bet.numDraws,
            betProperties: ['PROLONGATION'],
            betAmountSalesGroup1: bet.betAmountSalesGroup1,
            betAmountSalesGroup2: bet.betAmountSalesGroup2,
            rowPriceMulti: bet.rowPriceMulti,
            [boardName]: boards.map(b => _objectSpread(_objectSpread(_objectSpread({
              rowPriceMulti: b.rowPriceMulti,
              boardProps: [],
              systemType: isSystemWager ? ['MSYS'] : ['SROW'],
              participation: b.participation
            }, b.boardData && {
              boardData: b.boardData
            }), b.boardData1 && {
              boardData1: b.boardData1
            }), b.boardData2 && {
              boardData2: b.boardData2
            }))
          };
        })
        .sort((a, b) => productMapping.isJoker(a) - productMapping.isJoker(b))
      }];
    }
  }
  next({
    product: productMapping.getProductId(product),
    price,
    wagers: apiWagers,
    syndicateId
  });
}
svs.numbergames.pay_numbergames.fetchWager = fetchWager;

 })(window);